export default "__VITE_ASSET__W4geQPyF__"